import axios from 'axios'

import interceptorsInit from './interceptors/init'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
    'Accept': 'application/json'
  }
})

interceptorsInit(apiClient, ['errors', 'progress', 'lang'])

export default apiClient
